import React, { useState, useEffect } from "react";
import { Link } from "react-router-dom";
import {
  Button,
  Card,
  CardBody,
  CardTitle,
  Col,
  Container,
  Form,
  Input,
  Label,
  Row,
  FormFeedback
} from "reactstrap";
import { useSelector, useDispatch } from "react-redux";
import { isEmpty } from "lodash";
import Breadcrumbs from "../../../components/Common/Breadcrumb";
import "react-rangeslider/lib/index.css"
import "react-draft-wysiwyg/dist/react-draft-wysiwyg.css";
import { useFormik } from "formik";
import * as Yup from "yup";
import {
  updateAbout as onUpdateAbout,
  getAbout as onGetAbout,
} from "store/contacts/actions";

import Editor from 'ckeditor5-custom-build/build/ckeditor';
import { CKEditor } from '@ckeditor/ckeditor5-react'
import Dropzone from 'react-dropzone-uploader';
import { Base64 } from 'js-base64';
import toastr from 'toastr'; // toastr kütüphanesini içe aktarın
import 'toastr/build/toastr.min.css'; // toastr stillerini içe aktarın


function uploadPlugin(editor) {
  editor.plugins.get("FileRepository").createUploadAdapter = (loader) => {
    return uploadAdapter(loader);
  };
}

const EcommerceAddProduct = () => {
  document.title = "Hakkımızda Bilgileri | Süvari Kurye Admin Paneli";

  const dispatch = useDispatch();

  const [getContactEdit, setContactEdit] = useState(null);
  const [getHtmlDataLong, setHtmlDataLong] = useState(null);



  const getUploadParams = ({ file }) => {
    const body = new FormData();
    body.append('dataFile', file);
    return { url: 'https://megaadmin.stechomeyazilim.info:8080/uploadfile', body }
  }
  const Preview = ({ meta }) => {
    const { name, percent, status, previewUrl } = meta;
    return (
      <div className="preview-box">
        <img src={previewUrl} /> <span className="name">{name}</span> - <span className="status">{status == "done" ? "Başarıyla Yüklendi" : "Yükleniyor"}</span>{status !== "done" && <span className="percent"> ({Math.round(percent)}%)</span>}
      </div>
    )
  }



  const validation = useFormik({
    enableReinitialize: true,
    initialValues: {


      mail: (getContactEdit && getContactEdit.Mail) || '',
      number: (getContactEdit && getContactEdit.PhoneNumber) || '',
      web: (getContactEdit && getContactEdit.CompanyName) || '',
      address: (getContactEdit && getContactEdit.Address) || '',
      lat: (getContactEdit && getContactEdit.Lat) || '',
      long: (getContactEdit && getContactEdit.Long) || '',

      fbLink: (getContactEdit && getContactEdit.Fb_Link) || '',
      instagramLink: (getContactEdit && getContactEdit.Instagram_Link) || '',

      kmPrice: (getContactEdit && getContactEdit.KM_Price) || '',
    },
    validationSchema: Yup.object({

    }),
    onSubmit: (values) => {

      const updateOrder = {
        ID: users ? users[0].ID : 0,

        About_Desc: Base64.encode(getHtmlDataLong),
        Lat: parseFloat(values.lat),
        Long: parseFloat(values.long),
        CompanyName:values.web,
        PhoneNumber: values.number,

        Mail: values.mail,
     //   WebAdress: values.web,
        Address: values.address,
        
        Instagram_Link: values.instagramLink,
        Fb_Link: values.fbLink,
        KM_Price : parseFloat(values.kmPrice)
      };
      // update order

      showToast(true, "Başarıyla Güncellendi!");

      dispatch(onUpdateAbout(updateOrder));
      validation.resetForm();

    },
  });

  const { users } = useSelector(state => ({
    users: state.contacts.about,
  }));

  const showToast= async (type,message) => {
    let ele = null
   
  
     if(type == true){
       ele = "success"
       message = message
    } else{
       ele = "error"
       message = message
    };
    const position = ["toast-top-right"];
    let toastType;
    const title = "Başlık";
  
  
    //Close Button
    const closeButton = true;
  
    //Debug
    const debug = false;
  
    //Progressbar
    const progressBar = true;
  
    //Duplicates
    const preventDuplicates = false;
  
    //Newest on Top
    const newestOnTop = true;
  
    //position class
    let positionClass = "toast-top-right";
  
    //Show Easing
    const showEasing = "swing";
  
    //Hide Easing
    const hideEasing = "linear";
  
    //show method
    const showMethod = "fadeIn";
  
    //Hide method
    const hideMethod = "fadeOut";
  
    //show duration
    const showDuration = 300;
  
    //Hide duration
    const hideDuration = 1000;
  
    //timeout
    const timeOut = 5000;
  
    //extended timeout
    const extendedTimeOut = 1000;
  
    //Fetch checked Type
   
     toastType = ele;
    
  
    toastr.options = {
      positionClass: positionClass,
      timeOut: timeOut,
      extendedTimeOut: extendedTimeOut,
      closeButton: closeButton,
      debug: debug,
      progressBar: progressBar,
      preventDuplicates: preventDuplicates,
      newestOnTop: newestOnTop,
      showEasing: showEasing,
      hideEasing: hideEasing,
      showMethod: showMethod,
      hideMethod: hideMethod,
      showDuration: showDuration,
      hideDuration: hideDuration
    };
  
    // setTimeout(() => toastr.success(`Settings updated `), 300)
    //Toaster Types
    if (toastType === "info") toastr.info(message, title);
    else if (toastType === "warning") toastr.warning(message, title);
    else if (toastType === "error") toastr.error(message, title);
    else toastr.success(message, title);
  }

  useEffect(() => {
    if (users && !users.length) {
      dispatch(onGetAbout());

    }
  }, [dispatch, users]);

  useEffect(() => {
    if (users.length > 0) {
      setContactEdit(users[0]);

      setHtmlDataLong(Base64.decode(users[0].About_Desc))

    }
  }, [users]);

  useEffect(() => {
    if (!isEmpty(users)) {
      setContactEdit(users[0]);
    }
  }, [users]);

  return (
    <React.Fragment>
      <div className="page-content">
        <Container fluid>
          {/* Render Breadcrumb */}
          <Breadcrumbs title="Yönetim" breadcrumbItem="Hakkımızda Bilgileri" />

          <Row>
            <Col xs="12">
              <Card>
                <CardBody>
                  <CardTitle>Hakkımızda Bilgileri</CardTitle>

                  <Form
                    onSubmit={(e) => {
                      e.preventDefault();
                      validation.handleSubmit();
                      return false;
                    }}
                  >
                    <Row>

                      <div className="mb-3">
                        <Label htmlFor="productname">Mail Adresi</Label>
                        <Input
                          id="mail"
                          name="mail"
                          type="mail"
                          className="form-control"
                          placeholder="Mail Adresi"
                          validate={{
                            required: { value: true },
                          }}
                          onChange={validation.handleChange}
                          onBlur={validation.handleBlur}
                          value={validation.values.mail || ""}
                          invalid={
                            validation.touched.mail && validation.errors.mail ? true : false
                          }
                        />
                        {validation.touched.mail && validation.errors.mail ? (
                          <FormFeedback type="invalid">{validation.errors.mail}</FormFeedback>
                        ) : null}

                      </div>




                      <div className="mb-3">
                        <Label htmlFor="productname"> Adres </Label>
                        <Input
                          id="address"
                          name="address"
                          type="address"
                          className="form-control"
                          placeholder=" Adres"
                          validate={{
                            required: { value: true },
                          }}
                          onChange={validation.handleChange}
                          onBlur={validation.handleBlur}
                          value={validation.values.address || ""}
                          invalid={
                            validation.touched.address && validation.errors.address ? true : false
                          }
                        />
                        {validation.touched.address && validation.errors.address ? (
                          <FormFeedback type="invalid">{validation.errors.address}</FormFeedback>
                        ) : null}

                      </div>




                      <div className="mb-3">
                        <Label htmlFor="productname">Web Adresi </Label>
                        <Input
                          id="web"
                          name="web"
                          type="web"
                          className="form-control"
                          placeholder="Web Adresi"
                          validate={{
                            required: { value: true },
                          }}
                          onChange={validation.handleChange}
                          onBlur={validation.handleBlur}
                          value={validation.values.web || ""}
                          invalid={
                            validation.touched.web && validation.errors.web ? true : false
                          }
                        />
                        {validation.touched.web && validation.errors.web ? (
                          <FormFeedback type="invalid">{validation.errors.web}</FormFeedback>
                        ) : null}

                      </div>




                      <div className="mb-3">
                        <Label htmlFor="productname">Telefon Numarası </Label>
                        <Input
                          id="number"
                          name="number"
                          type="number"
                          className="form-control"
                          placeholder="Web Adresi"
                          validate={{
                            required: { value: true },
                          }}
                          onChange={validation.handleChange}
                          onBlur={validation.handleBlur}
                          value={validation.values.number || ""}
                          invalid={
                            validation.touched.number && validation.errors.number ? true : false
                          }
                        />
                        {validation.touched.number && validation.errors.number ? (
                          <FormFeedback type="invalid">{validation.errors.number}</FormFeedback>
                        ) : null}

                      </div>

                      <div className="mb-3">
                        <Label htmlFor="productname">Km Fiyatı </Label>
                        <Input
                          id="kmPrice"
                          name="kmPrice"
                          type="text"
                          className="form-control"
                          placeholder="Km Fiyatı"
                          validate={{
                            required: { value: true },
                          }}
                          onChange={validation.handleChange}
                          onBlur={validation.handleBlur}
                          value={validation.values.kmPrice || ""}
                          invalid={
                            validation.touched.kmPrice && validation.errors.kmPrice ? true : false
                          }
                        />
                        {validation.touched.kmPrice && validation.errors.kmPrice ? (
                          <FormFeedback type="invalid">{validation.errors.kmPrice}</FormFeedback>
                        ) : null}

                      </div>


                      <div className="mb-3">
                        <Label htmlFor="productname">Enlem </Label>
                        <Input
                          id="lat"
                          name="lat"
                          type="text"
                          className="form-control"
                          placeholder="Enlem"
                          validate={{
                            required: { value: true },
                          }}
                          onChange={validation.handleChange}
                          onBlur={validation.handleBlur}
                          value={validation.values.lat || ""}
                          invalid={
                            validation.touched.lat && validation.errors.lat ? true : false
                          }
                        />
                        {validation.touched.lat && validation.errors.lat ? (
                          <FormFeedback type="invalid">{validation.errors.lat}</FormFeedback>
                        ) : null}

                      </div>


                      <div className="mb-3">
                        <Label htmlFor="productname">Boylam </Label>
                        <Input
                          id="long"
                          name="long"
                          type="text"
                          className="form-control"
                          placeholder="Boylam"
                          validate={{
                            required: { value: true },
                          }}
                          onChange={validation.handleChange}
                          onBlur={validation.handleBlur}
                          value={validation.values.long || ""}
                          invalid={
                            validation.touched.long && validation.errors.long ? true : false
                          }
                        />
                        {validation.touched.long && validation.errors.long ? (
                          <FormFeedback type="invalid">{validation.errors.long}</FormFeedback>
                        ) : null}

                      </div>

                      <div className="mb-3">
                        <Label htmlFor="productname">Fb Link</Label>
                        <Input
                          id="fbLink"
                          name="fbLink"
                          type="text"
                          className="form-control"
                          placeholder="Facebook Link"
                          validate={{
                            required: { value: true },
                          }}
                          onChange={validation.handleChange}
                          onBlur={validation.handleBlur}
                          value={validation.values.fbLink || ""}
                          invalid={
                            validation.touched.fbLink && validation.errors.fbLink ? true : false
                          }
                        />
                        {validation.touched.fbLink && validation.errors.fbLink ? (
                          <FormFeedback type="invalid">{validation.errors.fbLink}</FormFeedback>
                        ) : null}

                      </div>

                      <div className="mb-3">
                        <Label htmlFor="productname">İnstagram Link </Label>
                        <Input
                          id="instagramLink"
                          name="instagramLink"
                          type="text"
                          className="form-control"
                          placeholder="İnstagram Link"
                          validate={{
                            required: { value: true },
                          }}
                          onChange={validation.handleChange}
                          onBlur={validation.handleBlur}
                          value={validation.values.instagramLink || ""}
                          invalid={
                            validation.touched.instagramLink && validation.errors.instagramLink ? true : false
                          }
                        />
                        {validation.touched.instagramLink && validation.errors.instagramLink ? (
                          <FormFeedback type="invalid">{validation.errors.instagramLink}</FormFeedback>
                        ) : null}

                      </div>

                      <div className="mb-3">
                        <Label className="form-label">Uzun Açıklama</Label>

                        <Form method="post">
                        <CKEditor
                            editor={Editor}
                            data={getHtmlDataLong}
                            config={{
                              // @ts-ignore
                              extraPlugins: [uploadPlugin]
                            }}
                            onReady={editor => {
                              // You can store the "editor" and use when it is needed.
                              console.log('Editor is ready to use!', editor);
                            }}
                            onChange={(event, editor) => {
                              const data = editor.getData();
                              setHtmlDataLong(data)

                            }}
                          />
                        </Form>
                      </div>


        
                    </Row>
                    <div className="d-flex flex-wrap gap-2">
                      <Button type="submit" color="primary" className="btn ">
                        Kaydet
                      </Button>
                      <Button type="submit" color="secondary" className=" ">
                        İptal
                      </Button>
                    </div>
                  </Form>
                </CardBody>
              </Card>


            </Col>
          </Row>
        </Container>
      </div>
    </React.Fragment>
  )
}

export default EcommerceAddProduct
